import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button2 from '../../../components/ui/Button2';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';
import Skeleton from 'react-loading-skeleton'; // استيراد Skeleton
import { useTranslation } from 'react-i18next';

const OrderSummary = ({ cartItems, onApplyPromoCode, onProceedToCheckout, isLoading }) => {
  const { t } = useTranslation();

  const isAuthenticated = localStorage.getItem('isAuthenticated');

  const [promoCode, setPromoCode] = useState('');
  const [promoError, setPromoError] = useState('');
  const [promoSuccess, setPromoSuccess] = useState('');
  const [isApplyingPromo, setIsApplyingPromo] = useState(false);

  // حساب subtotal، الشحن، والإجمالي
  const subtotal = cartItems.reduce((acc, item) => {
    const itemPrice = isAuthenticated
      ? item.product.has_discount
        ? item.product.price_after_discount
        : item.product.price
      : item.has_discount
      ? item.price_after_discount
      : item.price;

    return acc + itemPrice * item.quantity;
  }, 0);

  const shipping = 0; // نفترض أن الشحن مجاني
  const total = subtotal + shipping; // إضافة الشحن إلى subtotal للإجمالي

  const handleApplyPromo = async () => {
    if (!promoCode.trim()) {
      setPromoError(t('promoCodeRequired'));
      return;
    }

    setIsApplyingPromo(true);
    setPromoError('');
    setPromoSuccess('');

    // محاكاة استدعاء API
    setTimeout(() => {
      const validCodes = ['SAVE10', 'WELCOME20', 'SUMMER15'];

      if (validCodes.includes(promoCode.toUpperCase())) {
        setPromoSuccess(t('promoCodeApplied', { code: promoCode }));
        onApplyPromoCode(promoCode);
      } else {
        setPromoError(t('invalidPromoCode'));
      }

      setIsApplyingPromo(false);
    }, 1000);
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleApplyPromo();
    }
  };

  return (
    <div className="bg-card border border-border rounded-[16px] p-4 sm:p-6 sticky top-20">
      <h2 className="text-xl font-semibold text-foreground mb-6">{t('orderSummary')}</h2>

      {isLoading ? (
        <div>
          <Skeleton count={3} height={20} />
          <Skeleton count={1} height={40} className="mt-4" />
        </div>
      ) : (
        <>
          {/* تفصيل الأسعار */}
          <div className="space-y-3 mb-6">
            <div className="flex justify-between text-foreground">
              <span>{t('subtotal')}</span>
              <span>
                {subtotal} {t('IQD')}
              </span>
            </div>

            <div className="flex justify-between text-foreground">
              <span>{t('shipping')}</span>
              <span>{shipping === 0 ? t('free') : `${shipping} ${t('IQD')}`}</span>
            </div>

            <div className="border-t border-border pt-3">
              <div className="flex justify-between text-lg font-bold text-foreground">
                <span>{t('total')}</span>
                <span>
                  {total} {t('IQD')}
                </span>
              </div>
            </div>
          </div>
          {/* زر الدفع */}

          <Button2
            loading={isLoading}
            text={t('proceedToCheckout')}
            onClick={onProceedToCheckout}
            text_font_size="16"
            text_font_family="Gilroy-Bold"
            text_color="#ffffff"
            fill_background_color="#ca0d2d"
            border_border_radius="4px"
            padding="16px 34px 16px 34px"
            layout_width="100%"
            className="w-full hover:opacity-90 transition-opacity"
            position="relative"
            variant="default"
            size="medium"
          />

          {/* متابعة التسوق */}
          <button
            onClick={() => window.history.back()}
            className="w-full mt-2 py-1 text-16 font-gilroy-medium text-white bg-[#000] border border-[#000] rounded-[4px] hover:opacity-95 transition-all"
          >
            {t('continueShopping')}
          </button>
        </>
      )}
    </div>
  );
};

export default OrderSummary;
